import { useLocale } from '@/providers/LocaleProvider';
import { BaseSelectMenuOption } from '@/types/components/selector.types';
import { SxProps, ToggleButton, ToggleButtonGroup } from '@mui/material';

type Props = {
  value: any;
  items: BaseSelectMenuOption[];
  onChange: (value: any) => void;
  sx?: SxProps;
  exclusive?: boolean;
  disabled?: boolean;
};

export const AppCardSelect = ({
  value,
  items,
  onChange,
  sx,
  exclusive = true,
  disabled,
}: Props) => {
  const { translate } = useLocale();

  const handleChange = (e: React.MouseEvent, v: any) => {
    onChange(v);
  };

  const itemSx = {
    textTransform: 'none',
    px: '14px',
    py: '10px',
    borderRadius: '20px !important',
    fontFamily: 'Inter !important',
    border: '1px solid var(--neon-blue-nb-100) !important',
    height: '40px',
    minWidth: '80px',

    '&.Mui-selected': {
      color: 'white',
      bgcolor: 'var(--grey-gr-900)',
    },

    '&.Mui-selected:hover': {
      color: 'white',
      bgcolor: 'var(--grey-gr-900)',
    },

    '&:hover': {
      bgcolor: 'var(--grey-gr-200)',
    },

    '&.Mui-disabled': {
      opacity: 0.75,
      cursor: 'not-allowed',
    },
  };
  return (
    <ToggleButtonGroup
      value={value}
      exclusive={exclusive}
      onChange={handleChange}
      sx={[
        { gap: 1, display: 'flex !important', flexWrap: 'wrap !important' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      disabled={disabled}
    >
      {items.map((item, index) => (
        <ToggleButton key={index} value={item.value || ''} sx={itemSx}>
          {translate(item.label || '')}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
